import { Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'directory-portal-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit {
  private meta = inject(Meta);
  private titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle('404 – Page Not Found');
    this.meta.updateTag({
      name: 'description',
      content: 'The page you are looking for could not be found.',
    });
    this.meta.updateTag({ name: 'robots', content: 'noindex' });
  }
}
